module.exports = __webpack_public_path__ + "346e4ad1c1b634a1cb668b3e335e658f.pdf";